import InvTrnHeader1Editor from './components/InvTrnHeader1Editor';
import InvTrnHeader1Viewer from './components/InvTrnHeader1Viewer';
import InvTrnHeaderEmbEditor from './components/InvTrnHeaderEmbEditor';

import InvTrnHeader2 from './components/InvTrnHeader2';
import InvTrnHeaderSH1 from './components/InvTrnHeaderSH1';

import InvTrnTermsViewer from './components/InvTrnTermsViewer';
import InvTrnTermsEditor from './components/InvTrnTermsEditor';
import InvSalesTransaction from './components/InvSalesTransaction';
import InvSalesReturnsTransaction from './components/InvSalesReturnsTransaction';
import InvSalesCollection from "./components/InvSalesCollection";
import InvActionPayment from "./components/InvActionPayment";

import InvTaxBreakup from './components/InvTaxBreakup';
import InvTaxBreakupRow from './components/InvTaxBreakupRow';

import InvCostBreakup from './components/InvCostBreakup';
import InvCostBreakupRow from './components/InvCostBreakupRow'

import InvCashCreditBreakup from './components/InvCashCreditBreakup';
import InvCashCreditBreakupRow from './components/InvCashCreditBreakupRow';

import InvItemDetail from "./components/InvItemDetail"
import InvItemDetailEditor from './components/InvItemDetailEditor';
import InvItemDetailStoneEditor from './components/InvItemDetailStoneEditor';
import InvItemDetailMetalEditor from './components/InvItemDetailMetalEditor';
import InvExMaterialItemDetailEditor from './components/InvExMaterialItemDetailEditor';
import InvExpItemDetailEditor from './components/InvExpItemDetailEditor';
import InvItemDetailRow from './components/InvItemDetailRow';
import InvExpItemRow from "./components/InvExpItemRow";

import InvExpTrnFooter from './components/InvExpTrnFooter';
import InvInvoiceTrnFooter from './components/InvInvoiceTrnFooter';

import InvImportItemsHeader from './components/InvImportItemsHeader'; 
import InvImportItems from './components/InvImportItems';
import InvImportItemsRow from './components/InvImportItemsRow';

import InvBudgetBreakup from "./components/InvBudgetBreakup";
import InvBudgetBreakupRow from "./components/InvBudgetBreakupRow";

import InvParentLink from "./components/InvParentLink"; 
import InvParentLinkRow from "./components/InvParentLinkRow";

import InvItemMenuRow from "./components/InvItemMenuRow";
import InvItemDeliveryRow from "./components/InvItemDeliveryRow";
import InvItemDiscountRow from "./components/InvItemDiscountRow";

// import InvItemDeliveryEditor from "./components/InvItemDeliveryEditor";
import InvItemDiscountEditor from "./components/InvItemDiscountEditor";

import voucherViewMap from "../account/Index";
import cmnViewMap from '../cmn/Index';
import systemViewMap from '../system/Index';
import profileViewMap from '../profile/Index';

import DirectPrint from '../system/printers/DirectPrint';

import InvItemChildGroup from "./components/InvItemChildGroup";
import InvItemChildGroupRow from "./components/InvItemChildGroupRow";

import InvTrackHeader from "./components/InvTrackHeader";
import InvItemDetailBlockEditor from './components/InvItemDetailBlockEditor';
import InvTrnHeaderSH2 from './components/InvTrnHeaderSH2';
import InvPaymentStatus from './components/InvPaymentStatus';
import InvPaymentList from './components/InvPaymentList';
import InvPaymentListRow from './components/InvPaymentListRow';

const invViewMap = {
    "vInvTrnHeader1Viewer": InvTrnHeader1Viewer,
    "vInvTrnHeaderEmbEditor": InvTrnHeaderEmbEditor,
    "vInvTrnHeader1Editor": InvTrnHeader1Editor,
    "vInvTrnHeader2": InvTrnHeader2,
    "vInvInvoiceTrnFooter": InvInvoiceTrnFooter,
    "vInvExpTrnFooter":InvExpTrnFooter,
    "vInvTrnHeaderSH1": InvTrnHeaderSH1,
    "vInvTrnHeaderSH2": InvTrnHeaderSH2,
    "vInvTermsViewer": InvTrnTermsViewer,
    "vInvTermsEditor": InvTrnTermsEditor,
    "vInvSalesTransaction": InvSalesTransaction,
    
    "vInvSalesReturnsTransaction": InvSalesReturnsTransaction,
    "vInvActionPayment":InvActionPayment,
    "vInvSalesCollection":InvSalesCollection,
    "vInvTaxBreakup": InvTaxBreakup,
    "vInvTaxBreakupRow": InvTaxBreakupRow,
    "vInvCostBreakup": InvCostBreakup,
    "vInvCostBreakupRow": InvCostBreakupRow,

    "vInvCashCreditBreakup": InvCashCreditBreakup,
    "vInvCashCreditBreakupRow": InvCashCreditBreakupRow,

    "vInvBudgetBreakupRow": InvBudgetBreakupRow,
    "vInvBudgetBreakupEditor": InvBudgetBreakupRow,
    "vInvBudgetBreakup": InvBudgetBreakup,
    "vInvItemDetail": InvItemDetail,
    "vInvExMaterialItemDetailEditor":InvExMaterialItemDetailEditor,
    "vInvExpItemDetailEditor":InvExpItemDetailEditor,
    "vInvItemDetailStoneEditor":InvItemDetailStoneEditor,
    "vInvItemDetailMetalEditor":InvItemDetailMetalEditor,
    "vInvItemDetailBlockEditor":InvItemDetailBlockEditor,
    "vInvItemChildGroup":InvItemChildGroup,
    "vInvItemChildGroupRow":InvItemChildGroupRow,

    "vInvImportItemsHeader":InvImportItemsHeader,
    "vInvImportItems":InvImportItems, 
    "vInvImportItemsRow":InvImportItemsRow,
    "vInvExpItemRow":InvExpItemRow,
    "vInvItemDetailRow":InvItemDetailRow,
    
    "vInvItemDetailEditor": InvItemDetailEditor,
    
    "vInvItemMenuRow": InvItemMenuRow,
    "vInvItemMenuEditor": InvItemDetailEditor,

    "vInvItemDeliveryRow": InvItemDeliveryRow,
    "vInvItemDeliveryEditor": InvItemDetailEditor,

    "vInvItemDiscountRow": InvItemDiscountRow,
    "vInvItemDiscountEditor": InvItemDiscountEditor,

    "vInvParentLink":InvParentLink,
    "vinvParentLinkRow":InvParentLinkRow,

    "vInvTrackHeader":InvTrackHeader,

    "vInvPaymentStatus":InvPaymentStatus,
    "vInvPaymentList":InvPaymentList,
    "vInvPaymentListRow":InvPaymentListRow,

    "vDirectPrint": DirectPrint,

    ...voucherViewMap,
    ...profileViewMap,
    ...systemViewMap,
    ...cmnViewMap
}

export default invViewMap;
